var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickClose.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c(
          "div",
          { staticClass: "close-button", on: { click: _vm.onClickClose } },
          [
            _c("div", { staticClass: "icon" }, [_c("Close")], 1),
            _c("div", { staticClass: "label" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.close")) + " "),
            ]),
          ]
        ),
        _c("div", { staticClass: "dialog-title" }, [
          _vm._v(" " + _vm._s(_vm.$t("eventCompanyDialog.title")) + " "),
        ]),
        _vm._m(0),
        _c("div", [
          _c("div", { staticClass: "description-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("eventCompanyDialog.mainFeatures")) + " "
            ),
          ]),
          _c("div", { staticClass: "description-container" }, [
            _c("div", { staticClass: "description-box" }, [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: require("@/assets/img/event/company/reader.png"),
                  alt: "reader_icon",
                },
              }),
              _c("div", [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature1.title")) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature1.text")) +
                      " "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "description-box" }, [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: require("@/assets/img/event/company/board.png"),
                  alt: "board_icon",
                },
              }),
              _c("div", [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature2.title")) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature2.text")) +
                      " "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "description-box" }, [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: require("@/assets/img/event/company/reaction.png"),
                  alt: "reaction_icon",
                },
              }),
              _c("div", [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature3.title")) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("eventCompanyDialog.feature3.text")) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "main-image" }, [
      _c("img", {
        staticClass: "image",
        attrs: {
          src: require("@/assets/img/event/company/lying_cat.png"),
          alt: "main_image",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }